export default __webpack_public_path__ + "static/media/alfa_romeo.449f487c.svg";